import { useClickOutside } from '@common/hooks';
import { observer } from 'mobx-react';
import React, { useCallback, useRef, useState } from 'react';
import { HexColorPicker } from 'react-colorful';

interface IProps {
  color: string | undefined;
  onChange: (newColor: string) => void;
  isOverlay?: boolean;
  disabled?: boolean;
}

export const ColorPickerPopover = observer(
  ({ color, onChange, isOverlay, disabled }: IProps) => {
    const popover = useRef<HTMLDivElement>(null);
    const [isOpen, toggle] = useState(false);
    const close = useCallback(() => toggle(false), []);
    useClickOutside(popover, close);

    return (
      <div className={isOverlay ? 'picker' : ''}>
        <div
          className="swatch"
          style={{ backgroundColor: color }}
          onClick={() => toggle(true)}
        />

        {isOpen && !disabled && (
          <div className="popover" ref={popover}>
            <HexColorPicker color={color} onChange={onChange} />
          </div>
        )}
      </div>
    );
  },
);
